import React from 'react'
import { Chart } from 'primereact/chart'

function DoughnutChartV1({ value1, value2, labels, animate = true }) {

    const dynamicData = () => {
        const data = {
            labels: labels,
            datasets: [
                {
                    data: [value1, value2],
                    backgroundColor: [
                        '#E41B27',
                        '#CED2D2'
                    ],
                    hoverBackgroundColor: [
                        '#FF4550',
                        '#EBEDED'
                    ]
                }
            ]
        }
        return data
    }

    const options = {
        cutout: '40',
        animation: animate,
        plugins: {
            legend: {
                position: 'bottom'
            }
        },
    }

    if (value1 === 0 && value2 === 0) {
        return (
            <div style={{ height: '200px', display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#888' }}>
                Sem dados
            </div>
        )
    }

    return (
        <>
            <Chart type="doughnut" data={dynamicData()} options={options} style={{ height: '200px' }} />
        </>
    )
}
export default React.memo(DoughnutChartV1)